import { en } from './en';
import { no } from './no';

export const resources = {
  en,
  no,
} as const;

export type Language = keyof typeof resources;
export type Namespace = keyof typeof resources.en; 